import { render, staticRenderFns } from "./CreateTemplateMethod.vue?vue&type=template&id=1534f246"
import script from "./CreateTemplateMethod.vue?vue&type=script&lang=js"
export * from "./CreateTemplateMethod.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplateMethod.vue?vue&type=style&index=0&id=1534f246&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports